import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const chefsClubTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#000000',
    },
    secondary: {
      main: '#e33c50',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#e33c50',
    },
  },
};
